import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=11ff5227"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ff5227')) {
      api.createRecord('11ff5227', component.options)
    } else {
      api.reload('11ff5227', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=11ff5227", function () {
      api.rerender('11ff5227', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/division/record/Detail.vue"
export default component.exports